import RecommendedEmptyCardImage from "../../../assets/recommended-emptycard-image.png";
import { Card } from "@fluentui/react-components";
import { _blank } from "../../../utility/app-constants";
import { componentConstants, recommendationsGlowImagesConstants } from "../../../utility/app-constants";
import { RandomGlowImage } from "../../../utility/app-utilities";
/**
 * To display Recommended Card when no recomendation is aviliable
 * @returns 
 */
export default function RecommendedNoCard() {

    return (
        <div className="recommended-nocard-main">
            <Card className="recommended-card">
                <div className='recommended-card-content'>
                    <div className='recommended-text-div'>
                        <div className='recommended-text-content'>
                            <p className='recommended-header-text'>{componentConstants.recommendedEmptyResponseCardHeaderData}</p>
                            <p className='recommended-body-text'>{componentConstants.recommendedEmptyResponseCardBodyData}</p>
                        </div>
                    </div>
                    <div className='recommended-noimage-main'>
                        <img className="recommended-glow-image" src={RandomGlowImage(recommendationsGlowImagesConstants.glowImage as [])} />
                        <img className='recommended-image' width="100%" src={RecommendedEmptyCardImage} />
                    </div>
                </div>
            </Card>
        </div>
    );
}